import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { Color } from '../../theme';
import { Icon } from '../../ui';
import { debounce } from '../../utils';
import { StyleSearchIcon, StyledActionButton, StyledActionButtonContainer, StyledInput, StyledSearchItems, StyledWrapper, } from './SearchBox.style';
export function SearchBox({ id, label, children, placeholder, actionButton, onChange, debounceTime, }) {
    const [value, setValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const ref = useRef(null);
    const iconColor = value ? Color.Neutrals.Dark : Color.Neutrals.Text;
    const debouncedHandleChange = useCallback(debounce((value) => {
        setValue(value);
        onChange && onChange(value);
    }, debounceTime !== null && debounceTime !== void 0 ? debounceTime : 100), [onChange]);
    const resetHandler = useCallback(() => {
        if (ref.current)
            ref.current.value = '';
        debouncedHandleChange('');
    }, []);
    const handleFocus = useCallback(() => setIsFocused(true), []);
    const handleBlur = useCallback(() => setTimeout(() => setIsFocused(false), 200), []);
    const showActionButtons = useMemo(() => value || actionButton, [actionButton, value]);
    return (_jsxs(StyledWrapper, { children: [_jsx(StyledInput, { id: `search-box-input-${id}`, name: `search-box-input-${id}`, ref: ref, label: label, value: value, placeholder: placeholder, onChange: debouncedHandleChange, onFocus: handleFocus, onBlur: handleBlur }), _jsx(StyleSearchIcon, { children: _jsx(Icon, { color: iconColor, name: "search", size: "Medium" }) }), showActionButtons && (_jsxs(StyledActionButtonContainer, { children: [value && (_jsx(StyledActionButton, { onClick: resetHandler, children: _jsx(Icon, { color: iconColor, name: "cross", size: "Medium" }) })), actionButton && (_jsx(StyledActionButton, { onClick: actionButton.onClick, children: _jsx(Icon, { color: iconColor, name: actionButton.icon, size: "Medium" }) }))] })), isFocused && children] }));
}
export function SearchBoxDrawer({ children }) {
    return (_jsx(StyledSearchItems, { hasContent: !!children, children: children }));
}
//# sourceMappingURL=SearchBox.js.map